$(document).ready(
    function () {
        let p = $("body").attr("p");
        let a = $("body").attr("a");
        if (p === 'organizer_event_ticket_category' && a == 'list') {

            $(document).on("click", ".event-ticket-category-publish", function () {

                let selected_event_ticket_category = $(this).attr("data-publish-id");
                let wasDeactivated = false;
                if ($(this).hasClass('category-deactivated')) {
                    wasDeactivated = true;
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_event_ticket_category/publish",
                    data: {
                        event_ticket_category_id: selected_event_ticket_category
                    }
                })
                    .done(function (data) {

                        if (data === true) {
                            if (wasDeactivated) {
                                $('ul#event-ticket-category-mobile-id-' + selected_event_ticket_category).fadeOut(500, function () {
                                    $(this).remove();
                                });
                                $('tr#event-ticket-category-id-' + selected_event_ticket_category).fadeOut(500, function () {
                                    $(this).remove();
                                });
                            } else {
                                $(".event-ticket-category-id-publish-btn-" + selected_event_ticket_category).each(function () {
                                    $(this).remove();
                                });
                            }
                            popupAlert();
                        }

                    })
                    .fail(function (data) {

                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }

                    });

                return false;

            });
        }

    }
);